export const ENDPOINTS_ROOT = 'https://mijn.partnerselect.net/server_endpoints'; // TODO: Terug naar reguliere versie